@import '../../../theme.scss';

verdocs-tabs {
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  font-family: $primary-font;

  .tab {
    display: flex;
    color: #111111;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    padding: 5px 10px;
    align-items: center;
    text-transform: none;
    justify-content: center;
    border-bottom: 4px solid transparent;

    &:focus {
      border: none;
      outline: none;
    }

    &.active {
      color: #000000;
      font-weight: 500;
      border-bottom: 4px solid #654dcb;
    }

    &.disabled {
      color: #aaaaaa;
      cursor: default;
    }
  }
}
